import React, { Component } from 'react';

import Cache from '../frame/Cache';
import Config from '../config/Config';

import WidgetAjax from '../widget/WidgetAjax';

import "../css/association.css";

 class MultipointAssociation extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            basePath:Config.getBasePath(),
            url:"https://lingji.elecredit.com/#/embed-SingleBusiness?embed=1&sign=0b1bb53b4249e2c57900cf0c4eebc736dad66f3a26c637e7feb23d5eec107a53",
            // url:""
        }

        this.loadURL = this.loadURL.bind(this);
        this.onLoadURL = this.onLoadURL.bind(this);
    }

    componentDidMount()
    {
        this.loadURL();
    }

    loadURL() 
    {
        const { basePath } = this.state;

        const params = {
            service:"multiple"
        }

        WidgetAjax.ajax({ url: basePath + '/entity/graph', params: params, callback: this.onLoadURL });
    }

    onLoadURL(result, params )
    {
        if( result.status===0 )
        {
            this.setState({url: result.result.url});
        }
        else if(  result.status===10 ) 
        {
            Cache.logout(this.props);
        }

    }

    render() 
    {
        const { url } = this.state;

        return (
            <div className='MultipointAssociation-page'>
                <div className='MultipointAssociation-page-body'>
                    <iframe frameborder={0} width={"100%"} height={'100%'} src = {url} >
                        {"当前浏览器不支持此页面，请使用谷歌浏览器打开此页面"}
                    </iframe>
                </div>
            </div>
        )
    }
}

export default MultipointAssociation;